export const ADD = 'app/EditSessionPage/Multi/ADD';
export const ADD_NONE_OF_THE_ABOVE =
  'app/EditSessionPage/Multi/ADD_NONE_OF_THE_ABOVE';
export const UPDATE = 'app/EditSessionPage/Multi/UPDATE';
export const REMOVE = 'app/EditSessionPage/Multi/REMOVE';
export const REMOVE_NONE_OF_THE_ABOVE =
  'app/EditSessionPage/Multi/REMOVE_NONE_OF_THE_ABOVE';
export const REORDER = 'app/EditSessionPage/Multi/REORDER';
